import React from "react";
import ReactDOM from "react-dom/client";
import AppRouter from "./routes/Router"; // ルーティングを管理するコンポーネント
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";


// MUIのテーマ設定（任意）
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppRouter /> 
    </ThemeProvider>
  </React.StrictMode>
);
